import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {availableDocs, InternalDocummentID} from "../document-types";
import {MatDivider} from "@angular/material/divider";
import {FuseAlertComponent} from "../../../../@fuse/components/alert";
import {NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {
    AcordPacientInformatSibV2Wizzard
} from "../acord-pacient-informat/acord-pacient-informat-sib-v2/wizzard/acord.pacient.informatsib.v2";
import {BasicPatientInfoWizzard} from "../basic-info/wizzard/basic-patient-info-wizzard.component";
import {
    BuletinInformativWizzardSibV1
} from "../chest-eval-gen-stare-sanatate/buletin-informativ-sib-v2/wizzard/buletin.informativ.wizzard.sib.v1";
import {GdprWizzardSibV1} from "../GDPR-consimtamant/gdpr-sib-v1/wizzard/gdpr.wizzard.sib.v1";

@Component({
    selector     : 'forms-wizards',
    templateUrl  : './wizards.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [MatIconModule, FormsModule, ReactiveFormsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDivider, FuseAlertComponent, NgIf, NgSwitchCase, AcordPacientInformatSibV2Wizzard, NgSwitch, BasicPatientInfoWizzard, BuletinInformativWizzardSibV1, GdprWizzardSibV1],
})
export class FormsWizardsComponent implements OnInit
{
    infoVisible: boolean = false;
    doc_ID:InternalDocummentID;

    verticalStepperForm: UntypedFormGroup;
    @Input()
    set docID(docID: string) {
        this.doc_ID = InternalDocummentID[docID];
    }


    /**
     * Constructor
     */
    constructor(private _formBuilder: UntypedFormBuilder)
    {

    }

    getDocummentInfo(){
        return availableDocs[this.doc_ID];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void
    {

        // Vertical stepper form
        this.verticalStepperForm = this._formBuilder.group({
            step1: this._formBuilder.group({
                email   : ['', [Validators.required, Validators.email]],
                country : ['', Validators.required],
                language: ['', Validators.required],
            }),
            step2: this._formBuilder.group({
                firstName: ['', Validators.required],
                lastName : ['', Validators.required],
                userName : ['', Validators.required],
                about    : [''],
            }),
            step3: this._formBuilder.group({
                byEmail          : this._formBuilder.group({
                    companyNews     : [true],
                    featuredProducts: [false],
                    messages        : [true],
                }),
                pushNotifications: ['everything', Validators.required],
            }),
        });
    }

    protected readonly DocummentID = InternalDocummentID;
}
